const monthList = [
  {
    id: 1,
    title: 'Jan',
    value: {
      start: 1,
      end: 31,
      monthIndex: 1,
    },
  },
  {
    id: 2,
    title: 'Feb',
    value: {
      start: 1,
      end: 28,
      monthIndex: 2,
    },
  },
  {
    id: 3,
    title: 'Mar',
    value: {
      start: 1,
      end: 31,
      monthIndex: 3,
    },
  },
  {
    id: 4,
    title: 'Apr',
    value: {
      start: 1,
      end: 31,
      monthIndex: 4,
    },
  },
  {
    id: 5,
    title: 'May',
    value: {
      start: 1,
      end: 31,
      monthIndex: 5,
    },
  },
  {
    id: 6,
    title: 'Jun',
    value: {
      start: 1,
      end: 31,
      monthIndex: 6,
    },
  },
  {
    id: 7,
    title: 'July',
    value: {
      start: 1,
      end: 31,
      monthIndex: 7,
    },
  },
  {
    id: 8,
    title: 'Aug',
    value: {
      start: 1,
      end: 31,
      monthIndex: 8,
    },
  },
  {
    id: 9,
    title: 'Sep',
    value: {
      start: 1,
      end: 31,
      monthIndex: 9,
    },
  },
  {
    id: 10,
    title: 'Oct',
    value: {
      start: 1,
      end: 31,
      monthIndex: 10,
    },
  },
  {
    id: 11,
    title: 'Nov',
    value: {
      start: 1,
      end: 31,
      monthIndex: 11,
    },
  },
  {
    id: 12,
    title: 'Dec',
    value: {
      start: 1,
      end: 31,
      monthIndex: 12,
    },
  },
];

export { monthList };

export default monthList;
